import {
  SelectContractResponse,
  SelectedContractDetails,
} from '../models/login.model';
import { User, UserByUuidResponse } from '../models/user.model';
import { AuthService } from '../services/auth.service';
import { UserFacade } from '../store/user/user.facade';

export interface SelectContractMappedResult {
  userResponse: UserByUuidResponse;
  userUuid: string;
  contractDetails: SelectedContractDetails | null;
}

export function mapSelectContractResponse(
  response: SelectContractResponse
): SelectContractMappedResult {
  const userResponse: UserByUuidResponse = {
    status: 'success',
    data: {
      uuid: response.user.uuid,
      firstName: response.user.firstName,
      lastName: response.user.lastName,
      displayName: response.user.displayName,
      email: response.user.email,
      login: response.user.login,
      document: response.user.document,
      documentType: response.user.documentType,
      role: response.user.role,
      business: response.user.business,
      phone: response.user.phone,
      addresses: response.user.addresses as unknown as User['addresses'],
      terms: response.user.terms as unknown as User['terms'],
      confirmationUrl: response.user.confirmationUrl,
      origin: response.user.origin,
      accessChannel: response.user.accessChannel,
      userType: response.user.userType,
    },
  };

  let contractDetails: SelectedContractDetails | null = null;
  if (response.contract?.billing) {
    const b = response.contract.billing;
    contractDetails = {
      operatorCode: b.operatorCode,
      customerAccountId: String(b.customerAccountId ?? ''),
      customerName: b.customerName,
      customerValue: b.customerValue,
      email: b.email,
      phone: b.phone,
      mobilePhone: b.mobilePhone,
      status: b.status,
      contractType: b.contractType,
    };
  }

  return {
    userResponse,
    userUuid: response.user.uuid,
    contractDetails,
  };
}

export function applySelectContractToSession(
  response: SelectContractResponse,
  authService: AuthService,
  userFacade: UserFacade
): void {
  const mapped = mapSelectContractResponse(response);
  authService.updateStoredLoginData({ userUuid: mapped.userUuid });
  userFacade.loadUserDetailsSuccess(mapped.userResponse);
  if (mapped.contractDetails) {
    userFacade.setSelectedContractSuccess(mapped.contractDetails);
  }
}
